import FilterChip from 'LuxKit/Chips/FilterChip'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { countOccupants, formatOccupantsForSelectionBox } from 'lib/offer/occupancyUtils'
import { generateOfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import { isTourV2Offer } from 'lib/offer/offerTypes'
import { isSalesforceTourV2 } from 'lib/offer/offerUtils'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  selected?: boolean
  rooms?: Array<App.Occupants>
  variant?: 'dropdown' | 'modal'
  offer: App.Offer | App.BedbankOffer | App.Tours.TourV2Offer
  disableMultiRoom?: boolean
}

const defaultRooms = [generateOfferPageRoom()]
const OfferCalendarCapacityChip = React.forwardRef<HTMLButtonElement, Props>(
  function OfferCalendarCapacityChip(props, ref) {
    const { onClick, rooms = defaultRooms, offer, selected, variant, disableMultiRoom } = props
    const intl = useIntl()

    const allRooms = useMemo(() => countOccupants(rooms), [rooms])
    const selectGuestsLabel = intl.formatMessage({
      id: 'MTxo8lqH5d',
      defaultMessage: 'Select guests',
      description: 'Placeholder text for guest capacity chip when no guests are selected',
    })
    const value = useMemo(() => {
      if (rooms.length > 0) {
        const occupantsText = formatOccupantsForSelectionBox(isTourV2Offer(offer) && isSalesforceTourV2(offer), allRooms)
        const roomText = disableMultiRoom ? '' : pluralizeToString(offer.saleUnit, rooms.length)
        // TODO: localise this - why do you do this...
        return `${occupantsText} ${roomText ? ` (${roomText})` : ''}`
      }

      return selectGuestsLabel
    }, [allRooms, disableMultiRoom, offer, rooms.length, selectGuestsLabel])

    return <FilterChip
      size="medium"
      ref={ref}
      onClick={onClick}
      endIcon={variant === 'dropdown' ? <DropdownChevron open={selected} /> : undefined}
      selected={selected}
    >
      {value}
    </FilterChip>
  },
)

type MappedProps = Pick<Props, 'rooms'>

export default withOfferPageState((state): MappedProps => ({
  rooms: state.rooms,
}), OfferCalendarCapacityChip)
